export default __webpack_public_path__ + "static/media/bank of america logo.af329640.png";